import { gql } from "@apollo/client";

export default gql`
  mutation DeletePost($id: ObjectId!) {
    deletePost(id: $id)
  }
`;
